module.exports = __webpack_public_path__ + "img/record-bg.dd3f3e0c.png";